import React, { FormEvent, useEffect, useState } from 'react';
import Preorder from '../../../../models/Preorder';
import { GenericModalDialog } from '../../../modalDialog/GenericModalDialog';
import { statusPreorderNamesTranslated } from '../../../Utils/Filters';
import { Stack, Box, TextField, CircularProgress, Typography, Paper, Button, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { preorderClosingStatus, statusPreorderNameTranslated } from '../../../Utils/CommonConst';
import { SessionState } from '../../../../reducers/auth/session';
import { CarrierListState } from '../../../../reducers/carrier/carrierList';
import { DeliveryLocationListState } from '../../../../reducers/deliveryLocation/deliveryLocationList';
import { AppState } from '../../../../reducers';
import { fetchCarriers } from '../../../../actions/carrier/carrierList';
import { connect, useDispatch } from 'react-redux';
import { fetchDeliveryLocations } from '../../../../actions/deliveryLocation/deliveryLocationList';
import DeliveryLocation, { commonChacoDeliveryLocation, commonDeliveryLocation } from '../../../../models/DeliveryLocation';
import { formattedCurrency, leadingZeroes } from '../../../../utils/StringUtils';
import { ClientDetailState } from '../../../../reducers/client/clientDetail';
import { fetchClient } from '../../../../actions/client/clientDetail';
import { useThemeContext } from '../../../../theme/ThemeContext';
import Carrier from '../../../../models/Carrier';
import moment, { Moment } from 'moment';
import AutocompleteSelector from '../../../Utils/AutocompleteSelector';
import { fetchDeliveryAreas } from '../../../../actions/deliveryArea/deliveryAreaList';
import DeliveryArea from '../../../../models/DeliveryArea';
import { DeliveryAreaListState } from '../../../../reducers/deliveryArea/deliveryAreaList';
import { fetchLogisticWarnings } from '../../../../actions/logisticWarning/logisticWarningList';
import LogisticWarning from '../../../../models/LogisticWarning';
import { LogisticWarningListState } from '../../../../reducers/logisticWarning/logisticWarningList';
import { AttachFile } from '@mui/icons-material';
import { ProvinceListState } from '../../../../reducers/province/provinceList';
import { LocalityListState } from '../../../../reducers/locality/localityList';
import Locality from '../../../../models/Locality';
import { pushAlert } from '../../../../actions/alert';
import { DesktopDatePicker, LocalizationProvider } from '@mui/lab'
import AdapterMoment from '@mui/lab/AdapterMoment'
import { IncotermsListState } from '../../../../reducers/incoterms/incotermsList';
import Incoterms from '../../../../models/Incoterms';
import { fetchIncoterms } from '../../../../actions/incoterms/incotermsList';
import { fetchLocalities } from '../../../../actions/deliveryLocation/localityList';


interface ClosePreorderProps {
  onConfirm: (preorder: Preorder, files: File[], event: FormEvent) => void
  onCancel: () => void
  isUpdating?: boolean
  preorder: Preorder
  carrierList?: CarrierListState
  deliveryLocationList?: DeliveryLocationListState
  deliveryAreaList?: DeliveryAreaListState
  logisticWarningList?: LogisticWarningListState
  provinceList?: ProvinceListState
  incotermsList?: IncotermsListState
  localityList?: LocalityListState
  client?: ClientDetailState
  session?: SessionState
  total?: number
  prepaymentDescription?: string
}


const searchLocalityByAddress = (
  localities: Locality[],
  dl: DeliveryLocation
): Locality | undefined => {
  const normalizar = (texto: string): string =>
    texto
      .toLowerCase()
      .normalize('NFD') // elimina tildes
      .replace(/[\u0300-\u036f]/g, '') // limpia los residuos de tildes
      .replace(/[^\w\s]/g, '') // elimina signos de puntuación
      .trim();

  const direccionNormalizada = normalizar(dl.domicilio);

  const palabrasIgnoradas = new Set(['de', 'la', 'el', 'los', 'las', 'da', 'del']);

  for (let i = 0; i < localities.length; i++) {
    const localityIt = localities[i];
    //    const base = normalizar(localityIt.descripcion.split(' ')[0]);
    //    if (direccionNormalizada.includes(base) &&
    //      dl.codigopostal.toString() === localityIt.codigo_postal.toString() && dl.codigo_provincia.toString() === localityIt.codigo_provincia.toString()

    const palabras = normalizar(localityIt.descripcion)
      .split(/\s+/)
      .filter(p => p.length > 2 && !palabrasIgnoradas.has(p) &&
        dl.codigopostal.toString() === localityIt.codigo_postal.toString() && dl.codigo_provincia.toString() === localityIt.codigo_provincia.toString())

    const hayCoincidencia = palabras.some(palabra =>
      direccionNormalizada.includes(palabra)
    );
    if (hayCoincidencia) {
      return localityIt;
    }
  }

  return undefined;
}


export const ClosePreorderDialog: React.FC<ClosePreorderProps> = (props) => {
  const { t } = useTranslation(['preorder', 'menu'])
  const dispatch = useDispatch()
  const { theme } = useThemeContext()
  const [delivery, setDelivery] = useState<DeliveryLocation | undefined>(undefined)
  const [carrier, setCarrier] = useState<Carrier | undefined>(undefined)
  const [deliveryArea, setDeliveryArea] = useState<DeliveryArea | undefined>(undefined)
  const [locality, setLocality] = useState<Locality | undefined>(undefined)
  const [incoterms, setIncoterms] = useState<Incoterms | undefined>(undefined)
  const [logisticWarning, setLogisticWarning] = useState<LogisticWarning | undefined>(undefined)
  const [carrierAreaDescription, setCarrierAreaDescription] = useState<string | undefined>(undefined)
  const [status, setStatus] = useState<string | undefined>(props.preorder.status === 'D' ? 'D' : undefined)
  const [preorderInfo, setPreorderInfo] = useState<Preorder>({
    ...props.preorder,
    status: undefined, warehouse: props.session?.isChaco ? props.preorder.warehouse !== 3 ? props.preorder.warehouse : 3 : props.preorder.warehouse
  })
  const [deliveryLocations, setDeliveryLocations] = useState<DeliveryLocation[] | undefined>(undefined)
  const [attached, setAttached] = useState<number>(0)
  const [showUploadFile, setShowUploadFile] = useState<boolean>(false)
  const [files, setFiles] = useState<File[]>([])

  const fileInputs = [React.useRef<HTMLInputElement>(null)]

  const changeInternalRemarks = (newInternalRemarks: string) => {
    const lines = newInternalRemarks.split('\n').map(line => line.slice(0, 50)); // Completa con espacios hasta 50 caracteres
    // Máximo 5 líneas de 50 caracteres cada una
    setPreorderInfo({ ...preorderInfo, internalRemarks: lines.slice(0, 5).join('\n') })
  }

  const changeHoldedRemarks = (newHoldedRemarks: string) => {
    setPreorderInfo({ ...preorderInfo, holdedRemarks: newHoldedRemarks })
  }

  const changeRejectedRemarks = (newRejectedRemarks: string) => {
    setPreorderInfo({ ...preorderInfo, rejectedRemarks: newRejectedRemarks })
  }


  const changeStatus = (newStatus: string) => {
    if (newStatus) {
      setPreorderInfo({ ...preorderInfo, status: newStatus })
    }
  }

  const changePurchaseOrder = (newPurchaseOrder: string) => {
    if (newPurchaseOrder) {
      setPreorderInfo({ ...preorderInfo, purchaseOrder: newPurchaseOrder })
    }
  }


  const changeLocality = () => {
    if (locality) {
      setPreorderInfo({
        ...preorderInfo, dl_localityCode: Number(locality.codigo_localidad),
        dl_provinceCode: locality.codigo_provincia
      })
      //asi solo lo pisaria si esta en 0 -> dl_provinceCode: preorderInfo.dl_provinceCode ? preorderInfo.dl_provinceCode : locality.codigo_provincia })
    }
  }


  const changeIncoterms = () => {
    if (incoterms) {
      setPreorderInfo({ ...preorderInfo, incotermCode: incoterms.codigo_incoterms })

    }
  }

  const changeDelivery = () => {
    if (delivery) {
      setPreorderInfo({
        ...preorderInfo,
        dl_address: delivery.domicilio,
        dl_locality: delivery.localidad,
        dl_provinceCode: delivery.codigo_provincia,
        dl_main: delivery.principal,
        dl_zipCode: delivery.codigopostal,
        dl_phone: delivery.telefono,
        dl_openingHours: delivery.horariodeatencion,
        dl_localityCode: delivery.codigo_localidad,
        deliveryAddressId: delivery.orden,
        dl_deliveryArea: delivery.codigo_zonadereparto ? delivery.codigo_zonadereparto : undefined
      })
    }
  }

  const changeCarrier = () => {
    if (carrier) {
      setPreorderInfo({
        ...preorderInfo,
        transportId: carrier.codigo_transporte,
        carrierArea: carrier.codigo_zonadereparto ? carrier.codigo_zonadereparto : undefined
      })
      setCarrierAreaDescription(carrier.codigo_zonadereparto ? carrier.zonasdereparto_descripcion : undefined)
    }
  }

  const changeDeliveryArea = () => {
    if (deliveryArea) {
      setPreorderInfo({
        ...preorderInfo,
        dl_deliveryArea: deliveryArea.codigo_zonadereparto ? deliveryArea.codigo_zonadereparto : undefined
      })
    }
  }

  const changeLogisticWarning = () => {
    if (logisticWarning) {
      setPreorderInfo({
        ...preorderInfo,
        logisticWarning: logisticWarning.codigo_advertencia ? logisticWarning.codigo_advertencia : undefined
      })
    }
  }

  const changeManualEstimatedDeliveryDate = (newDate: Moment | null) => {
    if (newDate) {
      const manualEstimatedDeliveryDate = newDate.tz("America/Argentina/Buenos_Aires").format()
      setPreorderInfo({ ...preorderInfo, manualEstimatedDeliveryDate })
    }
    else setPreorderInfo({ ...preorderInfo, manualEstimatedDeliveryDate: '' })
  }

  useEffect(() => {
    dispatch(fetchCarriers('?all=true'))
    dispatch(fetchDeliveryAreas('?all=true'))
    dispatch(fetchLogisticWarnings('?all=true'))
    dispatch(fetchIncoterms('?all=true'))
    dispatch(fetchClient(props.preorder.clientId.toString()))
    dispatch(fetchDeliveryLocations(`?codigo_cliente=${props.preorder.clientId}`))
  }, [dispatch, props.preorder.clientId])

  useEffect(() => {
    if ((props.localityList?.localities?.length ?? 0) === 0 && !props.localityList?.isFetching) {
      dispatch(fetchLocalities('?all=true'))
    }
  }, [dispatch, props.localityList?.localities?.length, props.localityList?.isFetching, props.preorder.clientId])

  useEffect(() => {
    if (props.client && !props.client?.isFetching && props.carrierList && !props.carrierList?.isFetching)
      if (props.session?.isChaco && !props.carrierList?.carriers?.find(c => props.client?.client?.codigo_transporte === c.codigo_transporte)) {
        setCarrier(props.carrierList?.carriers?.find(c => c.codigo_transporte === 9998))
        if( props.preorder.status === 'D' )
          setPreorderInfo(prev => ({ ...prev, transportId: 9998 }))
      } else
        if( props.preorder.status === 'D' && props.preorder.transportId )
          setCarrier(props.carrierList?.carriers?.find(c => props.preorder.transportId === c.codigo_transporte))
        else
          setCarrier(props.carrierList?.carriers?.find(c => props.client?.client?.codigo_transporte === c.codigo_transporte))
  }, [props.client, props.preorder, props.carrierList, props.client?.isFetching, props.carrierList?.isFetching, props.session?.isChaco])

  useEffect(() => {
    if (props.deliveryAreaList && !props.deliveryAreaList?.isFetching && delivery) {
      setDeliveryArea(props.deliveryAreaList?.deliveryAreas?.find(c => delivery.codigo_zonadereparto === c.codigo_zonadereparto))
      if (delivery.principal === -98)
        setLocality(searchLocalityByAddress(props.localityList?.localities || [], delivery))
      else {
        console.log('entro por aca 4')
        if (props.session?.isChaco && !props.localityList?.localities?.find(c => delivery.codigo_localidad.toString() === c.codigo_localidad.toString() &&
          delivery.codigopostal.toString() === c.codigo_postal.toString() && delivery.codigo_provincia.toString() === c.codigo_provincia.toString())) {
          setLocality(props.localityList?.localities?.find(c => c.codigo_localidad === 14421))
          if ( props.preorder.status === 'D' )
            setPreorderInfo(prev => ({ ...prev, dl_localityCode: 14421 }))
        }
        else {
          console.log('paso por 4 por el else y props.preorder.dl_localityCode vale ', props.preorder.dl_localityCode, delivery.codigo_localidad)
          if( props.preorder.dl_localityCode && !delivery.codigo_localidad && props.preorder.status === 'D')
            setLocality(props.localityList?.localities?.find(c => props.preorder.dl_localityCode?.toString() === c.codigo_localidad.toString()))
        else
          setLocality(props.localityList?.localities?.find(c => delivery.codigo_localidad.toString() === c.codigo_localidad.toString() &&
            delivery.codigopostal.toString() === c.codigo_postal.toString() && delivery.codigo_provincia.toString() === c.codigo_provincia.toString()))
        }
      }
    }
  }, [props.deliveryAreaList, props.preorder, props.deliveryAreaList?.isFetching, props.localityList, props.localityList?.isFetching, delivery, props.session?.isChaco])

  useEffect(() => {
    if (props.localityList && !props.localityList?.isFetching && locality) {

      if (props.session?.isChaco && !props.localityList?.localities?.find(c => locality.codigo_localidad === c.codigo_localidad &&
        locality.codigo_postal === c.codigo_postal && locality.codigo_provincia === c.codigo_provincia)) {
        setLocality(props.localityList?.localities?.find(c => c.codigo_localidad === 14421))
        if ( props.preorder.status === 'D' )
           setPreorderInfo(prev => ({ ...prev, dl_localityCode: 14421 }))
      }
      else
        setLocality(props.localityList?.localities?.find(c => locality.codigo_localidad === c.codigo_localidad &&
          locality.codigo_postal === c.codigo_postal && locality.codigo_provincia === c.codigo_provincia))
    }
  }, [props.localityList, props.preorder, props.localityList?.isFetching, locality, props.session?.isChaco])

  useEffect(() => {
    if (props.logisticWarningList && !props.logisticWarningList?.isFetching && logisticWarning) {
      setLogisticWarning(props.logisticWarningList?.logisticWarnings?.find(c => logisticWarning.codigo_advertencia === c.codigo_advertencia))
    }
  }, [props.logisticWarningList, props.logisticWarningList?.isFetching, logisticWarning])

  useEffect(() => {
    if (props.incotermsList && !props.incotermsList?.isFetching && incoterms) {
      setIncoterms(props.incotermsList?.incoterms?.find(c => incoterms.codigo_incoterms === c.codigo_incoterms))
    }
  }, [props.incotermsList, props.incotermsList?.isFetching, incoterms])

  useEffect(() => {
    if (props.deliveryLocationList && !props.deliveryLocationList?.isFetching)
      if (props.client?.client?.codigo_cliente && props.deliveryLocationList.deliveryLocations &&
        props.deliveryLocationList.deliveryLocations.length > 0) {
        if (!props.deliveryLocationList.deliveryLocations.find(dl => dl.codigo_cliente.toString() === props.client?.client?.codigo_cliente.toString()))
          setDeliveryLocations([ !props.session?.isChaco ? commonDeliveryLocation : commonChacoDeliveryLocation])
        else
          setDeliveryLocations([...props.deliveryLocationList.deliveryLocations || [], !props.session?.isChaco ? commonDeliveryLocation : commonChacoDeliveryLocation])
      }
      else
        setDeliveryLocations([!props.session?.isChaco ? commonDeliveryLocation : commonChacoDeliveryLocation])

  }, [props.client?.client?.codigo_cliente, props.session, props.deliveryLocationList, props.deliveryLocationList?.isFetching])

  useEffect(() => {
    if (deliveryLocations && props.preorder) {
      if (props.preorder.dl_main === -98) {
        setDelivery({ ...commonDeliveryLocation, domicilio: props.preorder.dl_address!, principal: props.preorder.dl_main!, codigopostal: props.preorder.dl_zipCode!, localidad: props.preorder.dl_locality!, codigo_provincia: props.preorder.dl_provinceCode! })
        if (!deliveryLocations.find(dl => dl.principal === -98))
          setDeliveryLocations([...deliveryLocations, { ...commonDeliveryLocation, domicilio: props.preorder.dl_address!, principal: props.preorder.dl_main!, codigopostal: props.preorder.dl_zipCode!, localidad: props.preorder.dl_locality!, codigo_provincia: props.preorder.dl_provinceCode! }])
      }
      else
        setDelivery(deliveryLocations.find(dl => dl.domicilio === props.preorder.dl_address &&
          dl.localidad === props.preorder.dl_locality &&
          dl.codigo_provincia.toString() === props.preorder.dl_provinceCode!.toString()
          //&& dl.principal.toString() === props.preorder.dl_main!.toString()
        )!)
    }
  }, [deliveryLocations, props.preorder])

  useEffect(() => {
    if (!locality && props.localityList && !props.localityList?.isFetching && props.preorder) {
      console.log('entro por aca 5')
      if (props.session?.isChaco && !props.localityList?.localities?.find(c => props.preorder.dl_localityCode?.toString() === c.codigo_localidad.toString()))
        {
          setLocality(props.localityList?.localities?.find(c => c.codigo_localidad === 14421))
          setPreorderInfo(prev => ({ ...prev, dl_localityCode: 14421 }))
        } else {
        console.log('paso por 5 por el else y props.preorder.dl_localityCode vale ', props.preorder.dl_localityCode)
        setLocality(props.localityList?.localities?.find(c => props.preorder.dl_localityCode?.toString() === c.codigo_localidad.toString()))
        }
    }
    // eslint-disable-next-line     
  }, [props.preorder, props.localityList, props.localityList?.isFetching])


  useEffect(() => {
    changeDelivery()
    // eslint-disable-next-line     
  }, [delivery])

  useEffect(() => {
    changeLocality()
    // eslint-disable-next-line     
  }, [locality])

  useEffect(() => {
    changeIncoterms()
    // eslint-disable-next-line     
  }, [incoterms])

  useEffect(() => {
    changeCarrier()
    // eslint-disable-next-line     
  }, [carrier])

  useEffect(() => {
    changeDeliveryArea()
    // eslint-disable-next-line     
  }, [deliveryArea])

  useEffect(() => {
    changeLogisticWarning()
    // eslint-disable-next-line     
  }, [logisticWarning])

  useEffect(() => {
    if (status)
      changeStatus(status)
    // eslint-disable-next-line     
  }, [status])


  const setAttachedFileInfo = async (fileNumber: number) => {
    const files = (fileInputs[fileNumber - 1] as any).current.files as File[];
    if (files.length && files[0]) {
      setFiles(files)
      setAttached(attached + 1)
    }
  }

  return <GenericModalDialog isOpen={true}
    dialogProps={{ open: true, maxWidth: "lg" }}
    onConfirm={(event) => {
      if (preorderInfo?.dl_main?.toString() === '-99' && status !== 'P') {
        dispatch(pushAlert(t('deliveryLocationRequired'), true))
        event?.preventDefault();
        event?.stopPropagation();
        return false;
      }
      props.onConfirm?.(preorderInfo, files, event!);
    }}
    onCancel={() => props.onCancel && props.onCancel()}
    submit
    title={t('closeTitle')}>
    <Stack style={{ display: 'flex', flexDirection: 'column' }}>
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", borderRadius: "5px", bgcolor: theme.palette.success.main }}>
        <Paper elevation={2}
          style={{
            padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
            textAlign: "justify", justifyContent: "space-around",
            borderRadius: "5px", margin: "2px"
          }}>
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {props.preorder &&
              <Box display="flex" alignItems="flex-start">
                <Typography fontWeight="bold" variant="body1">{t('number')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{props.preorder.id}</Typography>
              </Box>
            }
            {props.preorder &&
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="body1">{t('date')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{moment(props.preorder.dateUpdated ? props.preorder.dateUpdated : props.preorder.dateCreated).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>}
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {props.preorder && props.preorder.prepaymentId &&
              <Box display="flex" alignItems="flex-end">
                <Typography fontWeight="bold" variant="body1">{t('prepaymentId')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{props.preorder.prepaymentId}&nbsp;&nbsp;-&nbsp;&nbsp;{props.prepaymentDescription}</Typography>
              </Box>
            }
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {props.preorder &&
              <Box display="flex" alignItems="flex-start">
                <Typography fontWeight="bold" variant="body1">{t('status')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">&nbsp;&nbsp;{statusPreorderNameTranslated(props.preorder.status!, t)}</Typography>
              </Box>
            }
            {props.preorder &&
              <Box display="flex" alignItems="flex-end">
                <Typography fontWeight="bold" variant="body1">{t('subtotal')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">
                  {props.total ? formattedCurrency(props.total) : props.preorder.detail && formattedCurrency(props.preorder.detail.reduce((amount, det) => amount + Number(det.amount), 0))}
                </Typography>
              </Box>
            }
          </Box>
          <Box display="flex" flexDirection="row" justifyContent="space-between">
            {props.preorder &&
              <Box display="flex" alignItems="flex-start">
                <Typography fontWeight="bold" variant="body1">{t('client')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{props.preorder.clientId} - {props.client?.client?.nombrefantasia || ''}</Typography>

              </Box>
            }
          </Box>

          {props.preorder && props.preorder.remarks &&
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography fontWeight="bold" variant="body1">{t('remarksTitle')}:&nbsp;&nbsp;</Typography>
              <Typography variant="body1">
                {props.preorder.remarks}
              </Typography>
            </Box>}

        </Paper>
      </Paper>

      {props.carrierList &&
        props.deliveryLocationList &&
        props.client &&
        props.incotermsList &&
        !props.carrierList?.isFetching &&
        !props.deliveryLocationList?.isFetching &&
        !props.incotermsList?.isFetching &&
        !props.client?.isFetching &&
        <Box style={{ width: "770px", justifyContent: 'center' }}>
          <AutocompleteSelector
            label={t("status")}
            name="status"
            textAdapter={statusPreorderNamesTranslated}
            menuItems={props.preorder.status === 'A' ? preorderClosingStatus.filter(p => p !== 'H' && p !== 'C') :
              props.preorder.status === 'H' ? preorderClosingStatus.filter(p => p !== 'H') : preorderClosingStatus}
            onDataChange={setStatus}
            value={status}
            style={{ margin: "8px 10px 20px" }}
            getOptionLabel={(option: string) => statusPreorderNamesTranslated(option)}
            isOptionEqualToValue={(option, value) => option === value}
            disabled={(status === 'D' && !!props.session?.isChaco && preorderInfo.warehouse !== 3) || (status === 'P' && !props.session?.isChaco && preorderInfo.warehouse === 3)}
            required
          />
          {preorderInfo?.dl_main?.toString() !== '-1' &&
            <AutocompleteSelector value={delivery} onDataChange={setDelivery} name="delivery" label={t("delivery")}

              style={{ maxWidth: "750px", width: "750px", margin: "8px 10px 10px" }}
              menuItems={deliveryLocations}
              getOptionLabel={(option:
                {
                  domicilio: string,
                  localidad: string,
                  codigo_provincia: number,
                  codigopostal: number,
                  principal: number
                }) => {
                return `${option?.domicilio} - ${option?.localidad}`
              }}
              isOptionEqualToValue={(option, value) =>
                option?.domicilio === value?.domicilio &&
                option?.localidad === value?.localidad &&
                option?.codigopostal === value?.codigopostal &&
                option?.codigo_provincia === value?.codigo_provincia &&
                option?.principal === value?.principal
              }
              error={preorderInfo?.dl_main?.toString() === '-99' && status !== 'P'}
              helperText={preorderInfo?.dl_main?.toString() === '-99' && status !== 'P' ? t('deliveryLocationRequired') : ''}
              required={status !== 'P'} />}
          {preorderInfo?.dl_main?.toString() === '-1' &&
            <TextField
              key="manualDeliveryLocation"
              value={`${preorderInfo.dl_address} ${preorderInfo.dl_zipCode ? `(${preorderInfo.dl_zipCode})` : ``} ${preorderInfo.dl_locality ? `- ${preorderInfo.dl_locality}` : ``} ${preorderInfo.dl_provinceCode ? `- (${preorderInfo.dl_provinceCode}) - ${props.provinceList?.provinces?.find(province => preorderInfo.dl_provinceCode?.toString() === province.codigo_provincia.toString())?.descripcion}` : ``}`}
              style={{ maxWidth: "750px", width: "750px", margin: "8px 10px 10px" }}
              variant="outlined"
              label={t("manualDelivery")}
              multiline
              minRows={1}
              maxRows={3}
              disabled
            />
          }
          <Stack flexDirection='row' alignItems='center' justifyContent="space-between">
            <AutocompleteSelector
              value={locality}
              onDataChange={setLocality}
              name="locality"
              label={t("localityCode")}
              style={{ maxWidth: "750px", width: "750px", margin: "8px 10px", display: 'inline-flex' }}
              menuItems={props.localityList?.localities}
              required
              getOptionLabel={(option: { codigo_localidad: string, descripcion: string, codigo_postal: string, codigo_provincia: string }) => {
                return `${option?.descripcion} - [${leadingZeroes(option?.codigo_localidad, 5)}] - [CP ${leadingZeroes(option?.codigo_postal, 4)}] - [${props.provinceList?.provinces?.find(province => option.codigo_provincia?.toString() === province.codigo_provincia.toString())?.descripcion}]`
              }}
              isOptionEqualToValue={(option, value) =>
                option?.codigo_localidad === value?.codigo_localidad &&
                option?.codigo_postal === value?.codigo_postal &&
                option?.codigo_provincia === value?.codigo_provincia
              }
            />
            {props.client.client?.usaIncoterms &&
              <AutocompleteSelector value={incoterms} onDataChange={setIncoterms} name="incoterms" label={t("incoterms")}
                style={{ maxWidth: "460px", width: "460px", margin: "8px 10px", display: 'inline-flex' }}
                required
                menuItems={props.incotermsList?.incoterms}
                getOptionLabel={(option: { codigo_incoterms: string, descripcion: string }) => {
                  return `${option?.descripcion} - [${option?.codigo_incoterms}]`
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.codigo_incoterms === value?.codigo_incoterms
                }
              />
            }
          </Stack>
          <TextField
            key="purchaseOrder"
            value={preorderInfo.purchaseOrder}
            style={{
              width: "300px", margin: '8px 10px'
            }}
            variant="outlined"
            onChange={event => changePurchaseOrder(event.target.value)}
            inputProps={{ maxLength: 50 }}
            label={t('purchaseOrder')}
          />
          {!props.session?.isChaco && <AutocompleteSelector value={deliveryArea} onDataChange={setDeliveryArea} name="deliveryArea" label={t("deliveryArea")}
            style={{ maxWidth: "315px", width: "315px", margin: "8px 10px", display: 'inline-flex' }}
            menuItems={props.deliveryAreaList?.deliveryAreas}
            getOptionLabel={(option: { codigo_zonadereparto: string, descripcion: string }) => {
              return `${option?.descripcion} - [${leadingZeroes(option?.codigo_zonadereparto, 4)}]`
            }}
            isOptionEqualToValue={(option, value) =>
              option?.codigo_zonadereparto === value?.codigo_zonadereparto
            }
            required />}
          {props.session?.isChaco && <AutocompleteSelector value={carrier} onDataChange={setCarrier} name="carrier" label={t("carrier")}
            style={{ maxWidth: "315px", width: "315px", margin: "8px 10px", display: 'inline-flex' }}
            menuItems={props.carrierList?.carriers}
            getOptionLabel={(option: { codigo_transporte: string, nombre: string }) => {
              return `${option?.nombre} - [${leadingZeroes(option?.codigo_transporte, 4)}]`
            }}
            isOptionEqualToValue={(option, value) =>
              option?.codigo_transporte === value?.codigo_transporte
            }
            required />}

          <TextField
            key="warehouse"
            select
            value={preorderInfo.warehouse ?? ''}
            onChange={(e) => {
console.log(props.session?.isChaco, preorderInfo.warehouse, e.target.value, 
                preorderInfo.warehouse !== Number(e.target.value), Number(e.target.value) === 4)
              if (props.session?.isChaco && preorderInfo.warehouse !== Number(e.target.value) && Number(e.target.value) === 4) {
                setStatus('D');
              }
              if (!props.session?.isChaco && props.preorder.warehouse === 4 && Number(e.target.value) === 3) {
                setStatus('P');
              }
              if (props.session?.isChaco && props.preorder.warehouse === 4 && Number(e.target.value) === 3) {
                setStatus('P');
              }
              if (props.session?.isChaco && preorderInfo.warehouse === 4 && Number(e.target.value) === 3) {
                setStatus(undefined);
              }
              setPreorderInfo({ ...preorderInfo, warehouse: Number(e.target.value) });
            }}
            sx={{
              width: "95px", margin: '8px 10px',
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: theme.palette.action.disabled
              },
              "& .MuiFormLabel-root.Mui-disabled": {
                color: theme.palette.action.disabled,
              }
            }}
            variant="outlined"
            label={t('warehouse')}
            disabled={!props.session?.isChaco && props.preorder.status !== 'D'}
          >
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
          </TextField>


          {!props.session?.isChaco && <AutocompleteSelector value={carrier} onDataChange={setCarrier} name="carrier" label={t("carrier")}
            style={{ maxWidth: "460px", width: "460px", margin: "8px 10px", display: 'inline-flex' }}
            menuItems={props.carrierList?.carriers}
            getOptionLabel={(option: { codigo_transporte: string, nombre: string }) => {
              return `${option?.nombre} - [${leadingZeroes(option?.codigo_transporte, 4)}]`
            }}
            isOptionEqualToValue={(option, value) =>
              option?.codigo_transporte === value?.codigo_transporte
            }
            required />}
          {!props.session?.isChaco && <TextField
            key="carrierArea"
            value={`[${preorderInfo.carrierArea ? preorderInfo.carrierArea : 0}] - ${carrierAreaDescription ? carrierAreaDescription : ''}`}
            inputProps={{ style: { textAlign: 'left' } }}
            sx={{
              width: "270px", margin: '8px 10px',
              "& .MuiInputBase-input.Mui-disabled": {
                WebkitTextFillColor: theme.palette.action.disabled
              },
              "& .MuiFormLabel-root.Mui-disabled": {
                color: theme.palette.action.disabled,
              }
            }}
            variant="outlined"
            //onChange={event => changepurchaseOrder(event.target.value)}
            label={t('carrierArea')}
            disabled={true}
          />}

          {status === 'C' &&
            !props.session?.isChaco &&
            <Stack flexDirection='row' alignItems='center' justifyContent="space-between">
              <AutocompleteSelector value={logisticWarning} onDataChange={setLogisticWarning} name="logisticWarning" label={t("logisticWarning")}
                style={{ maxWidth: "460px", width: "460px", margin: "8px 10px", display: 'inline-flex' }}
                menuItems={props.logisticWarningList?.logisticWarnings}
                getOptionLabel={(option: { codigo_advertencia: string, descripcion: string }) => {
                  return `${option?.descripcion} - [${leadingZeroes(option?.codigo_advertencia, 4)}]`
                }}
                isOptionEqualToValue={(option, value) =>
                  option?.codigo_advertencia === value?.codigo_advertencia
                }
              />

              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DesktopDatePicker
                  label={t("estimatedDeliveryDate")}
                  inputFormat="DD/MM/yyyy"
                  minDate={moment()}
                  renderInput={(params) => <TextField sx={{ margin: "8px 10px", maxWidth: 270, svg: { fill: theme.typography.button.color } }} {...params} />}
                  value={preorderInfo.manualEstimatedDeliveryDate ? moment(new Date(preorderInfo.manualEstimatedDeliveryDate)) : null}
                  onChange={changeManualEstimatedDeliveryDate}
                />
              </LocalizationProvider>
            </Stack>}
          <Stack display={status !== 'H' && status !== 'R' ? 'none' : "flex"} flexDirection='row' alignItems='center' justifyContent="space-between" sx={{ marginBottom: "5px" }}>
            <Button disabled={attached > 0 || (status !== 'H' && status !== 'R')} size="small" style={{ textTransform: 'none', marginLeft: '8px', padding: "8px" }} onClick={(event: FormEvent) => { event.preventDefault(); event.stopPropagation(); setShowUploadFile(attached !== 1) }}>
              <AttachFile sx={{ color: theme.palette.success.dark }} />
              <Typography color={theme.palette.success.dark}>{t('attachFile')}</Typography>
            </Button>

            <TextField
              inputProps={{ accept: "application/pdf" }}
              inputRef={fileInputs[0]}
              margin="dense"
              size='small'
              variant="outlined"
              onChange={() => setAttachedFileInfo(1)}
              type="file"
              sx={{ marginRight: '5px', display: showUploadFile && attached >= 0 ? 'inherit' : 'none' }}
              disabled={status !== 'H' && status !== 'R'}
            />
          </Stack>
          {status !== 'H' && status !== 'R' && <TextField
            key="internalRemarks"
            value={preorderInfo.internalRemarks}
            style={{
              width: "750px", margin: '8px 10px'
            }}
            variant="outlined"
            multiline
            minRows={4}
            maxRows={5}
            rows={5}
            onChange={event => changeInternalRemarks(event.target.value)}
            helperText="Máximo 5 lineas, de 50 caracteres cada linea."
            label={t('remarks')}
          />}
          {status === 'H' && <TextField
            key="holdedRemarks"
            value={preorderInfo.holdedRemarks}
            style={{
              width: "750px", margin: '8px 10px'
            }}
            variant="outlined"
            multiline
            minRows={4}
            maxRows={4}
            onChange={event => changeHoldedRemarks(event.target.value)}
            label={t('holdedRemarks')}
          />}
          {status === 'R' && <TextField
            key="rejectedRemarks"
            value={preorderInfo.rejectedRemarks}
            style={{
              width: "750px", margin: '8px 10px'
            }}
            variant="outlined"
            multiline
            minRows={4}
            maxRows={4}
            onChange={event => changeRejectedRemarks(event.target.value)}
            label={t('rejectedRemarks')}
          />}
        </Box>
      }
      {(props.carrierList?.isFetching ||
        props.deliveryLocationList?.isFetching ||
        props.client?.isFetching ||
        props.isUpdating) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </Stack>
  </GenericModalDialog>
}


const mapStateToProps = (state: AppState) => ({
  carrierList: state.carrierList,
  deliveryLocationList: state.deliveryLocationList,
  deliveryAreaList: state.deliveryAreaList,
  logisticWarningList: state.logisticWarningList,
  incotermsList: state.incotermsList,
  client: state.clientDetail,
  session: state.session
})

export default connect(mapStateToProps, null)(ClosePreorderDialog)